export const DEFAULT_HEADER_IMAGE = 'https://files-demo.affinicar.com/template/images/car-part.jpg';
